// extracted by mini-css-extract-plugin
export default {"container":"CompanyLogo_container__weFWS","logoImg":"CompanyLogo_logoImg__OWaeD"};